import script from "./bg-image.vue?vue&type=script&setup=true&lang=ts"
export * from "./bg-image.vue?vue&type=script&setup=true&lang=ts"

import "./bg-image.vue?vue&type=style&index=0&id=79e84338&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e84338"]])

export default __exports__